export const CUT_MUSIC_EXAMPLE_IMAGES = {
  noCut: [{ name: 'no_cut', src: '/assets/img/cut_music_examples/no-cut.png' }],
  cut: [
    { name: '0', src: '/assets/img/cut_music_examples/example-0sec-v2.png' },
    { name: '30', src: '/assets/img/cut_music_examples/example-30sec-v2.png' },
    { name: '60', src: '/assets/img/cut_music_examples/example-60sec-v2.png' },
  ],
  shift: [{ name: 'shift', src: '/assets/img/cut_music_examples/shift.png' }],
  drop: [{ name: 'drop', src: '/assets/img/cut_music_examples/drop.png' }],
};

export const DATA_TEST_IDS = {
  MODAL: 'cut_music_help_modal',
  BODY: 'cut_music_help_body',
  TITLE: 'cut_music_help_modal_title',
  INTRO: 'cut_music_help_intro',
  CONFIRM: 'button_cut_music_help_modal',
  IMAGE: (name: string) => `cut_music_help_${name}_image`,
};
